/** @jsxRuntime classic */
/** @jsx jsx */
import { jsx } from '@emotion/core';
import { useContext } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { IconName } from '@fortawesome/fontawesome-svg-core';
import { useThemeSwitcher } from 'react-css-theme-switcher';

import doReturnTheme from '~src/styles/themeEngine';
import translate from '~src/i18n/translate';
import AppContext from '~src/contexts/AppContext';
import { EStyleObj } from '~src/types';
import { IconButtonProps } from '~components/_common/IconButton/IconButton';

export interface HomeButtonProps extends IconButtonProps {
  name: string;
  customIcon?: string;
  disabled?: boolean;
}

const HomeIcon: React.FC<HomeButtonProps> = ({
  name,
  iconStyle = 'fad',
  icon,
  customStyle,
  backgroundOff,
  click,
  color,
  customIcon,
  containerStyle,
  textStyle,
  disabled = false,
}) => {
  const { currentTheme } = useThemeSwitcher();
  const theme = doReturnTheme(currentTheme);

  const { appContextState } = useContext(AppContext);

  const style: EStyleObj = {
    container: {
      display: 'flex',
      justifyContent: 'flex-start',
      alignItems: 'center',
      borderRadius: '3px',
      height: '80px',
      minWidth: '200px',
      maxWidth: '200px',
      paddingLeft: '16px',
      paddingRight: '20px',
      margin: '20px 30px 10px 10px',
      cursor: disabled ? 'not-allowed' : 'pointer',
      outline: 'none',
      opacity: disabled ? 0.5 : 1,
    },
    containerWithHover: {
      ':hover': {
        backgroundColor:
          window.sessionStorage.getItem('appState') === 'superUser'
            ? theme.colors.highlightedSecondary
            : theme.colors.primaryLight,
      },
    },
    customIcon: {
      height: '50%',
      opacity: 0.8,
      marginRight: '3px',
    },
    text: {
      fontSize: '18px',
      userSelect: 'none',
      marginLeft: '3px',
      color: theme.colors.text.primary,
    },
    blue: {
      color: theme.colors.primary,
    },
    red: {
      color: theme.colors.red,
    },
    green: {
      color: theme.colors.green,
    },
    darkGray: {
      color: theme.colors.darkGray,
    },
    yellow: {
      color: theme.colors.yellow,
    },
    white: {
      color: theme.colors.white,
    },

    // ':focus': {
    //   border: `1px solid ${theme.colors.primary}`,
    // },
  };

  const styled = color ? [customStyle, style[color]] : customStyle;

  return (
    <div
      css={[
        style.container,
        !backgroundOff && !disabled && style.containerWithHover,
        containerStyle && containerStyle,
      ]}
      onClick={disabled ? undefined : click}
      role="button"
      tabIndex={0}>
      {customIcon ? (
        <img src={customIcon} css={[style.customIcon, styled]} alt="" />
      ) : (
        <FontAwesomeIcon icon={[iconStyle, icon as IconName]} css={styled} />
      )}

      <div css={[style.text, textStyle && textStyle]}>
        {translate(`${name}`)}
      </div>
    </div>
  );
};

export default HomeIcon;
